/**
 * Locale-aware number formatting for prices and counts.
 * French keeps "6 750", English shows "6,750". Only the display changes:
 * values, currency (THB) and calculations are untouched.
 */
import i18n from '@/i18n';

export const numberLocale = () =>
  ((i18n.resolvedLanguage || i18n.language || 'fr').startsWith('en') ? 'en-US' : 'fr-FR');
